
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { useClientInfo } from "@/hooks/use-client-info";
import { useSession } from "@/hooks/use-session";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const Profile = () => {
  const { session } = useSession();
  const { clientName, loading, schoolUser } = useClientInfo(session);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AppSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                Profile Settings
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                Manage your personal information and preferences
              </p>
            </div>

            <Card className="w-full max-w-2xl">
              <CardContent className="pt-6">
                {loading ? (
                  <div className="space-y-4">
                    <Skeleton className="h-6 w-3/4" />
                    <Skeleton className="h-6 w-2/3" />
                    <Skeleton className="h-6 w-1/2" />
                    <Skeleton className="h-6 w-2/3" />
                  </div>
                ) : (
                  <div className="space-y-4">
                    <div>
                      <label className="text-sm font-medium text-gray-500">Login sebagai</label>
                      <p className="text-lg text-gray-900">{session?.user?.email}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Nama Sekolah</label>
                      <p className="text-lg text-gray-900">{clientName || '-'}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Nomor HP</label>
                      <p className="text-lg text-gray-900">{schoolUser?.mobile_number || '-'}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Jabatan</label>
                      <p className="text-lg text-gray-900">{schoolUser?.role ? (
                        schoolUser.role.charAt(0).toUpperCase() + schoolUser.role.slice(1)
                      ) : '-'}</p>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Profile;
